'use client';

export const configureEcwid = environment => {
    window.localStorage.setItem('show_ec_logs', 'false');
    if (environment === 'development') {
        //window.localStorage.setItem('show_ec_logs', 'true');
    }
    window.ec = window.ec || {};
    window.ec.config = window.ec.config || {};
    window.ec.config.storefrontUrls = window.ec.config.storefrontUrls || {};
    window.ec.config.storefrontUrls.cleanUrls = true;
    window.ec.config.storefrontUrls.queryBasedCleanUrls = true;

    window.ec.storefront = window.ec.storefront || {};
    window.ec.storefront.show_breadcrumbs = false;
    window.ec.storefront.show_footer_menu = false;
    window.ec.storefront.show_root_categories = false;

    window.ecwid_script_defer = true;
    window.ecwid_dynamic_widgets = true;
};

export const loadEcwidScript = (storeId: string, onLoad: () => void) => {
    if (!document.getElementById('ecwid-script')) {
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `https://app.ecwid.com/script.js?${storeId}&data_platform=nextjs&storefront-v3=true`;
        script.id = 'ecwid-script';
        script.onload = onLoad;
        // eslint-disable-next-line no-console
        script.onerror = () => console.error('Failed to load Ecwid script');
        document.body.appendChild(script);
    } else {
        onLoad();
    }
};

export const handleOnAPILoaded = (callback: () => void) => {
    if (typeof window.Ecwid !== 'undefined') {
        window.Ecwid.OnAPILoaded.add(callback);
    } else {
        // eslint-disable-next-line no-console
        console.error('Ecwid API is not available');
    }
};
